<template lang="pug">
    router-link(v-if="ativo", tag="aside", :to="{ name: 'cursos', params: { tipo: 'graduacao' } }")#contador
        ul.timer
            li.casa.dias 
                | {{ this.countdown.dias | normalizeDigits }}
                small dias
            li.casa.horas 
                | {{ this.countdown.horas | normalizeDigits }}
                small horas
            li.casa.minutos 
                | {{ this.countdown.minutos | normalizeDigits }}
                small minutos
            li.casa.segundos 
                | {{ this.countdown.segundos | normalizeDigits }}
                small segundos
        .campanha
            h2 Super Promo
            h3 Garanta até 
                span 70% de desconto 
                | nos cursos de Graduação e Pós
        //- button(@click="ativo = false").fechar
        //-     include ../../assets/svgs/icones/icone-fechar-aside.svg
</template>

<script>
export default {
    name: "component-contador",
    data() {
        const finalDate = new Date('2021-08-15T23:59:59')
        const isActive = () => {
            if (finalDate.getTime() - new Date().getTime() < 0)
                return false
            return true
        }
        return {
            ativo: isActive(),
            finalDate,
            interval: null,
            countdown: {
                dias: 0,
                horas: 0,
                minutos: 0,
                segundos: 0,
            },
        }
    },
    filters: {
        normalizeDigits(value) {
            return value < 10 ? `0${ value }` : value
        },
    },
    mounted() {
        this.interval = setInterval(() => {
            let left = this.finalDate.getTime() - new Date().getTime()
            this.countdown = {
                dias: Math.floor(left / (1000 * 60 * 60 * 24)),
                horas: Math.floor((left % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutos: Math.floor((left % (1000 * 60 * 60)) / (1000 * 60)),
                segundos: Math.floor((left % (1000 * 60)) / 1000),
            }
            if (left < 0) {
                clearInterval(this.interval)
                this.ativo = false
            }
        }, 1000)
    },
}
</script>

<style lang="stylus" scoped src="./Contador.styl"></style>